import React from 'react'
import PropTypes from 'prop-types'
const IconButton = require('@material-ui/core/IconButton').default
const Menu = require('@material-ui/core/Menu').default
const MenuItem = require('@material-ui/core/MenuItem').default
const MoreVertIcon = require('@material-ui/icons/MoreVert').default

const ITEM_HEIGHT = 48

const EditOrDeleteMenuButton = ({
  options,
  handleChosenOption
}) => {

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = option => {
    handleChosenOption(option)
    setAnchorEl(null)
  }

  return (
    <div className="edit-or-delete-menu-button">
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        style={{ width: '48px' }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch'
          }
        }}
      >
        {options.map(option => (
          <MenuItem
            key={option}
            onClick={() => handleClose(option)}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}

EditOrDeleteMenuButton.propTypes = {
  options: PropTypes.array.isRequired,
  handleChosenOption: PropTypes.func.isRequired
}

export default EditOrDeleteMenuButton



// WEBPACK FOOTER //
// ./src/components/mini/Buttons/EditOrDeleteMenuButton.js